import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { useParams } from 'src/routes/hooks';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import KitchenDispatchOrderEditView from 'src/sections/kitchen-dispatches/view/kitchen-dispatch-edit-view';

export default function KitchenDispatchOrderEditPage() {
  const params = useParams();

  const { user: authUser } = useAuthContext();

  const { id } = params;

  return (
    <>
      <Helmet>
        <title>Edit dispatch order</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.CREATE_KITCHEN_INVENTORY_TRANSACTION,
        AuthPermissions.UPDATE_KITCHEN_INVENTORY_TRANSACTION,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <KitchenDispatchOrderEditView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
